import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [glitching, setGlitching] = useState(false);
  const glitchRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);

    const scheduleGlitch = () => {
      const delay = 3000 + Math.random() * 4000;
      glitchRef.current = setTimeout(() => {
        setGlitching(true);
        setTimeout(() => setGlitching(false), 600);
        scheduleGlitch();
      }, delay);
    };
    scheduleGlitch();

    return () => {
      clearTimeout(t);
      clearTimeout(glitchRef.current);
    };
  }, []);

  return (
    <div className="nf-page tc-page">
      {/* Background */}
      <div className="pd2-bg">
        <div className="nf-orb nf-orb1" />
        <div className="nf-orb nf-orb2" />
        <div className="nf-orb nf-orb3" />
        <div className="ck-grid" />
      </div>

      <div className={`nf-inner ${visible ? "vis" : ""}`}>

        {/* Eyebrow */}
        <div className="pd2-eyebrow nf-eyebrow">
          <span className="pd2-eyebrow-dot" />
          Error Code
        </div>

        {/* Giant 404 */}
        <div className={`nf-404 ${glitching ? "glitch" : ""}`} aria-label="404">
          <span className="nf-404-text" data-text="404">404</span>
        </div>

        {/* Accent divider */}
        <div className="nf-divider" />

        {/* Title */}
        <h1 className="nf-title">Hmm.. Something's Wrong!</h1>

        {/* Description */}
        <p className="nf-desc">
          The page you're looking for has been moved, deleted, or never existed.
          Check the URL or navigate back to safety.
        </p>

        {/* Actions */}
        <div className="nf-actions">
          <button className="pd2-btn-primary" onClick={() => navigate("/")}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            Back to Home
          </button>
          <button className="pd2-btn-ghost" onClick={() => navigate(-1)}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Go Back
          </button>
        </div>

        {/* Diagnostic strip */}
        <div className="nf-spec-strip">
          <div className="nf-spec-item">
            <span className="nf-spec-label">Status</span>
            <span className="nf-spec-val">404</span>
          </div>
          <div className="nf-spec-sep" />
          <div className="nf-spec-item">
            <span className="nf-spec-label">Path</span>
            <span className="nf-spec-val nf-spec-mono">{window.location.pathname}</span>
          </div>
          <div className="nf-spec-sep" />
          <div className="nf-spec-item">
            <span className="nf-spec-label">Origin</span>
            <span className="nf-spec-val nf-spec-mono">{window.location.hostname}</span>
          </div>
        </div>

      </div>
    </div>
  );
}